import { Injectable } from '@angular/core';
import Constants from '../constants/constants';
import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthUtilityService {

  constructor() { }

  /**
   * Builds the complete URL from path
   * @param path - API endpoint path
   * @returns Complete URL
   */
  buildUrl(path: string): string {
    // If path is already an absolute URL, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }

    // Remove leading slash if present to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Ensure base URL doesn't end with slash to avoid double slashes
    const cleanBaseUrl = Constants.API_BASE_URL.endsWith('/') ? Constants.API_BASE_URL.slice(0, -1) : Constants.API_BASE_URL;

    return `${cleanBaseUrl}/${cleanPath}`;
  }

  /**
   * Builds HTTP parameters from object
   * @param params - Parameters object
   * @returns HttpParams instance
   */
  buildParams(params?: { [key: string]: string | number | boolean }): HttpParams {
    let httpParams = new HttpParams();

    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
    }

    return httpParams;
  }

  /**
   * Merges additional headers with default headers
   * @param additionalHeaders - Additional headers to merge
   * @returns Merged HttpHeaders
   */
  mergeHeaders(additionalHeaders?: HttpHeaders): HttpHeaders {
    // Create HttpHeaders from default headers object
    let mergedHeaders = Constants.DEFAULT_HEADERS;

    if (additionalHeaders) {
      additionalHeaders.keys().forEach(key => {
        const value = additionalHeaders.get(key);
        if (value) {
          mergedHeaders = mergedHeaders.set(key, value);
        }
      });
    }

    return mergedHeaders;
  }

  /**
   * Handles HTTP errors
   * @param error - HTTP error response
   * @returns Observable error
   */
  handleError = (error: HttpErrorResponse): Observable<never> => {
    console.error('[AuthUtilityService] HTTP Error:', error);

    let errorMessage = 'An unknown error occurred!';

    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Client Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Server Error: ${error.status} - ${error.message}`;

      // Log additional server error details
      if (error.error) {
        console.error('[AuthUtilityService] Server Error Details:', error.error);
      }
    }

    return throwError(() => ({
      message: errorMessage,
      status: error.status,
      statusText: error.statusText,
      error: error.error
    }));
  };
}
